import { values } from 'lodash'
import { useSelector } from 'react-redux'
import { usePersons } from '../redux/reduxHooks'
import FamilyHelper from '../utils/FamilyHelper'

export const useFamilyHelperHook = ({ id }) => {
  const persons = usePersons() || {}
  const relationships = useSelector((state) => state.questionnaire.relationships || [])

  /**
   * Returns a list of sibling person objects
   * @returns {Array<string>} The current or updated input value.
   */
  function getSiblings() {
    const siblingPersons = values(new FamilyHelper({ persons, relationships }).getSiblings(id))

    return siblingPersons.map((item) => item.person.getDetailsObj())
  }
  /**
   * Returns a list of sibling ids
   * @returns {Array<string>} The current or updated input value.
   */
  function getSiblingIds() {
    const siblings = getSiblings() || []

    return siblings.map((person) => person.id)
  }

  return { persons, relationships, getSiblingIds, getSiblings }
}
